export const SHEET_NAME_CHARACTER_LIMIT = 31;
